import { SET_SITE } from "../constants";

const defaultState = {

    frontAdminPrimaryLogo: "",
    frontAdminSecondaryLogo: "",
    name: '',
    favicon: '',
    isIledgends: false,
    multiCompanyMode: false,
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case SET_SITE:
            return {
                ...state, ...action.site, isIledgends:
                    window.location.hostname.toLowerCase().includes('iledgends') ||
                    // window.location.hostname.toLowerCase().includes('stage') ||
                    false,
            };
        default:
    }

    return state;
}
